import { z } from "zod";
export const FeedbackSchema = z.object({
    id: z.string(),
    uid: z.string(),
    weddingId: z.string().nullable(),
    route: z.string().max(500),
    userAgent: z.string().max(500),
    text: z.string().min(1).max(2000),
    screenshotPath: z.string().nullable(),
    createdAt: z.unknown(),
});
